// Mutations
export const TOGGLE_COLLAPSE = 'core.toggle_collapsed'
export const SET_COLLAPSE = 'core.set_collapse'
